import axios from 'axios'
import { lib } from '@giscube/geoportal'
const L = lib.L

export function clearResult (context) {
  context.commit('errorFetching', false)
  context.commit('loading', false)
  context.commit('result', null)
  context.dispatch('deleteResultLayer')
}

export function deleteResultLayer (context) {
  const resultLayer = context.state.resultLayer
  if (resultLayer) {
    const map = context.rootState.map.mapObject
    map.removeLayer(resultLayer)
  }
  context.commit('resultLayer', null)
}

function addLayer (context, data) {
  const map = context.rootState.map.mapObject
  const resultLayer = L.geoJSON(data, {
    style: function (feature) {
      return { color: feature.properties.style_color }
    },
    onEachFeature: function (feature, layer) {
      let popup = ''
      for (let prop in feature.properties) {
        popup += '<div>' + prop.toUpperCase() + ': ' + feature.properties[prop] + '</div>'
      }
      layer.bindPopup(popup)
    }
  })
  context.commit('resultLayer', resultLayer)
  resultLayer.addTo(map)
}

export async function getGeoJSON (context, url) {
  await axios.get(url)
    .then(response => {
      if (response.statusText === 'OK') {
        addLayer(context, response.data)
      }
    })
    .catch(() => {
      context.commit('resultLayer', null)
    })
}

function JSONtoGeoJSON (data) {
  return {
    type: 'FeatureCollection',
    features: data.map(json => {
      return {
        type: 'Feature',
        properties: json,
        geometry: extractGeometry(json)
      }
    })
  }
}

function extractGeometry (data) {
  const geometry = {
    type: 'Point',
    coordinates: null
  }
  if (data.LONGITUD && data.LATITUD) {
    geometry.coordinates = [
      parseFloat(data.LONGITUD),
      parseFloat(data.LATITUD)
    ]
  }
  return geometry
}

export async function getJSON (context, url) {
  await axios.get(url)
    .then(response => {
      if (response.statusText === 'OK' && response.data && response.data.length > 0) {
        const geoJSON = JSONtoGeoJSON(response.data)
        addLayer(context, geoJSON)
      }
    })
    .catch(() => {
      context.commit('resultLayer', null)
    })
}

export async function searchById (context, id) {
  context.commit('errorFetching', false)
  context.commit('loading', true)
  const url = this.$config.opendata_api.url + 'package_show'
  await axios.get(url, {
    params: { id }
  })
    .then(response => {
      if (response.data.success) {
        context.commit('result', response.data.result)
      } else {
        context.commit('result', null)
        context.commit('errorFetching', true)
      }
    })
    .catch(() => {
      context.commit('errorFetching', true)
      context.commit('loading', false)
    })
  context.commit('loading', false)
}

export async function searchDataset (context) {
  context.commit('loading', true)
  const url = this.$config.opendata_api.url + 'package_search'
  const q = context.state.query
  await axios.get(url, {
    params: { q }
  })
    .then(response => {
      if (response.data.success) {
        context.commit('results', response.data.result.results)
      }
    })
    .catch(this.$except.http)
  context.commit('loading', false)
}
